import { CardTagsProps } from "@/types";
import cn, { join } from "@/utils/cn";

export default function CardTags({ tags, className, spanClassName, isPostionAbsolute = true }: CardTagsProps) {
  const isHiglighted = "bg-gold-20 text-black";
  return (
    <div
      className={cn(`${isPostionAbsolute ? "absolute top-s" : ""}  left-s flex ${isPostionAbsolute ? "flex-wrap" : "flex-col"} gap-xs`, className)}
    >
      {tags.map((tag, index) => (
        <span
          key={`tag-${index}`}
          className={join(
            `inline-block w-fit box-material-primary  backdrop-blur-xl rounded font-normal uppercase py-3xs p-[6px] text-s  before:rounded`,
            spanClassName,
            tag.isHiglighted ? isHiglighted : "text-white",
          )}
        >
          {tag.label}
        </span>
      ))}
    </div>
  );
}
